import { CustomTargetModelData } from '../../../../../model/custom-model/custom-target-model-data';
import { Dict } from '../../../../../model/dict';
import { OneYearCustomTargetModelData } from './year-by-year.service';

export function getOneYearChartData(
  dict: Dict<CustomTargetModelData>,
  year: number
): Dict<OneYearCustomTargetModelData> {
  let oneYearData: Dict<OneYearCustomTargetModelData> = {};
  Object.entries(dict).forEach(([key, value]) => {
    oneYearData[key] = {
      ...value,
      chartData: {
        carbonAbatement: value.chartData.carbonAbatement[year],
        emissions: value.chartData.emissions[year],
        target: value.chartData.target[year],
        outcome: value.chartData.outcome[year],
      },
    };
  });
  return oneYearData;
}
